<template>
    <div>
        <div v-if="errorMessages[error].icon == 'payment-option-unavailable'" class="d-flex flex-column align-items-center text-center bg-white pt-5 pb-4 pb-lg-4 px-3 mb-0 mb-lg-0">
            <img alt="" :src="`/img/hcpay/error/${errorMessages[error].icon}.svg`" class="errorMessageIcon img-responsive">
            <span class="font-md font-weight-bold text-gray-dk my-4">{{ errorMessages[error].header }}</span>
            <span class="font-sm font-weight-medium text-secondary">{{ errorMessages[error].subheader }}</span>
        </div>
        <div v-if="errorMessages[error].icon == 'homecredit-account-unavailable'" class="d-flex flex-column align-items-center text-center rounded py-4 px-3 bg-white my-2">
            <img alt="" :src="`/img/hcpay/error/${errorMessages[error].icon}.svg`" class="errorMessageIcon img-responsive">
            <span class="font-md font-weight-bold text-gray-dk my-4">{{ errorMessages[error].header }}</span>
            <span class="font-sm font-weight-medium text-secondary">{{ errorMessages[error].subheader }}</span>
            <span class="font-sm font-weight-medium text-tertiary">{{ errorMessages[error].subheaderOne }}</span>
        </div>

        <div v-if="errorMessages[error].icon == 'homecredit-account-unavailable'" class="d-flex flex-column align-items-center bg-white p-4">
            <download-opg-v3 
                class="px-4" 
                google-play-id="loginGooglePlayBtn" 
                qr-code-id="loginQRCode" 
                description="Get the latest version of the My Home Credit app on Google Play or scan the QR code below."
            />
        </div>

        <div class="d-flex flex-column rounded align-items-center py-4 bg-white my-2">
                <embed-video></embed-video>
                <span class="font-sm font-weight-medium text-secondary px-3 text-center pt-4">Manage payments, avail of loans, shop in installments, receive promos and many more with Home Credit app!</span>
                <br>
                <span class="font-sm font-weight-medium text-secondary px-3 text-center">To learn more about HCPay, <a class="link-hc-site text-green font-weight-bold" href="https://homecredit.ph/hcpay/">visit our website</a></span>
                <back-to-store v-if="!this.$root.$data.transaction.partnerId" class="pt-5">Back to store</back-to-store>
                <back-to-store v-else class="pt-5">Back to Merchant</back-to-store>
        </div>
    </div>
</template>
<script>
import { ERROR } from '../mixins/error_codes.js';

export default {
    data() {
        return {
            errorMessages: {
                [ERROR.PAYMENT_OPTION_UNAVAILABLE]: {
                    icon: 'payment-option-unavailable',
                    header: 'It’s nice that you already have the Home Credit app!',
                    subheader: "You need an HCPay account to pay for your online purchases, but don’t worry! We have a lot of features and products that can help you.",
                },
                [ERROR.HOMECREDIT_ACCOUNT_UNAVAILABLE]: {
                    icon: 'homecredit-account-unavailable',
                    header: "Looks like it’s our first time to see you here!",
                    subheader: "You don’t have an HCPay account and the Home Credit app yet, but once you do, you can enjoy our exciting deals and offers, including paying for your online purchases!",
                    subheaderOne: " Already have an account with us? Make sure your mobile number or Facebook account matches your details in the app, then retry your purchase.",
                },
            },
            error: this.$root.error
        }
    },
    created(){
        let g4params = {
            'userId': this.$root.$data.account.userId,
            'cuid': this.$root.$data.account.cuid,
            'ip': this.$root.transaction.ipAddress,
            'user_agent': this.$root.$data.analyticsData.userAgent,
            'phone': this.$root.$data.analyticsData.phone,
            'operating_system': this.$root.$data.analyticsData.operatingSystem.name+"V"+this.$root.$data.analyticsData.operatingSystem.version,
            'browser': this.$root.$data.analyticsData.browser.name+"V"+this.$root.$data.analyticsData.browser.version,
            'transaction_type': this.$root.$data.transaction.referenceNumber.substring(0, 2),
            'transaction_reference': this.$root.$data.transaction.referenceNumber,
        }       
        this.$root.triggerG4Event(this.pageEvent,g4params);
        this.$root.$data.previousView = 'not-available';
    },
    methods: {
        openSite(){
            window.location.href = "https://homecredit.ph/credit-card/";
        }
    }
}
</script>
<style scoped>
    .errorMessageIcon {
        height: auto;
        width: 9rem;
    }
    .paymentOptionCard {
        height: auto;
        width: 8rem;
    }
    .text-tertiary {
        color: #8C8C8C !important;
        margin-top: 1em;
    }
    .creditcardBg {
        background-color: #2196F3;
    }
    .walletpayBg {
        background-color: #009688;
    }
    .link-hc-site:hover{
        color: #49B672;
    }
</style>